export default __webpack_public_path__ + "static/media/Swami.fbb08d4a.png";